<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Observasi Peserta" @back="back">
            <common-training-header :withUser="true" :user_hash="user_hash" />
        </a-page-header>

        <a-card type="inner" size="small" >
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :columns="columns" :dataSource="items" rowKey="hash" :pagination="false" bordered>
                    <div slot="observation_date" slot-scope="record" style="text-align: center">
                        <strong>{{ record.observation_date }}</strong>
                    </div>

                    <div slot="description" slot-scope="record" style="text-align: left">
                        <p class="text-small">{{ record.description }}</p>
                    </div>

                    <div slot="action" slot-scope="record" style="text-align: center">
                        <a-button
                            size="small"
                            type="danger"
                            icon="delete"
                            @click="showConfirm(record.hash)"/>
                    </div>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
		key: 'observation_date',
		title: 'Tanggal',
        align: 'center',
        width: 150,
		scopedSlots: { customRender: 'observation_date' },
	}, {
		key: 'description',
		title: 'Observasi',
        align: 'center',
		scopedSlots: { customRender: 'description' }
	}, {
        key: 'action',
        title: 'Action',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'action' },
    },
]

export default {
    props: {
        user_hash: {
            type: String,
            required: true
        },
        modul: {
            type: String
        }
    },
    data() {
        return {
            columns,
            loading: false,
            items: {}
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.performance.observation.detail', {
                    user_hash: this.user_hash
                }))
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        back() {
            window.location.href = this.routeUri('admin.performance.mentoring.observation')
        },
        showConfirm(hash) {
            var msg = 'Anda yakin menghapus data?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.handleDelete(hash)
                },
                onCancel() {},
                class: 'test',
            });
        },
        handleDelete(hash) {
            this.processing = true;

            let promise;

            promise = this.$http.delete(
                this.routeUri("api.performance.observation.destroy", { observation: hash })
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.getItems()
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
    },
}
</script>
